import InformarCartaoResposta from "@pages/InformarCartaoResposta/InformarCartaoResposta";

export default InformarCartaoResposta;
